//@ts-nocheck
import React, { useState, useCallback } from 'react'
import {
  cbModal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  ButtonGroup,
  Checkbox,
  TextInput,
  Field,
  FieldLabel,
  ValidationMessage,
  ToggleSwitch,
  Tooltip,
  Icon
} from '../../../../../../index'
import { Transforms } from 'slate'
import { useSlate } from 'slate-react'

import { isLinkActive, wrapLink, getLinkDetail } from './utils'
import { onEnter } from '../../../utils/runOnKeyDown'
import { setOldSelection } from '../../../utils/setOldSelection'
import '../style.css'

const ModalComponent = (props) => {
  const { editor } = props
  const selection = editor.selection || editor.savedSelection
  const linkActive = isLinkActive(editor)
  const [formData, setFormData] = useState(getLinkDetail(editor, selection))
  const [errorMessage, setErrorMessages] = useState('')

  const handleChange = (e) => {
    e.persist()
    if (e.target.name === 'url') {
      if (e.target.value) {
        setErrorMessages('')
      } else {
        setErrorMessages('The URL provided is invalid. Please provide a valid one.')
      }
    }
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value
      }
    })
  }

  const handleToggle = (e) => {
    e.persist()
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.checked
      }
    })
  }

  const handleSubmit = () => {
    if (!formData['url']?.trim()) {
      setErrorMessages('The URL provided is invalid. Please provide a valid one.')
      return
    }
    if (selection) Transforms.select(editor, selection)
    if (formData['url']) {
      wrapLink(editor, formData['url'], formData['text'], formData['inNewTab'], formData['title'])
    } else {
      wrapLink(editor, '#', formData['text'], formData['inNewTab'], formData['title'])
    }
    props.closeModal()
  }

  const closeModal = () => {
    props.closeModal()
  }

  return (
    <div
      onKeyDown={(event) =>
        onEnter(event, () => {
          if (!errorMessage) {
            handleSubmit()
          }
        })
      }>
      <ModalHeader title="URL" closeModal={props.closeModal} />
      <ModalBody>
        <div className='FormFields'>
          <Field >
            <FieldLabel version='v2' htmlFor='url' required={true}>URL</FieldLabel>
            <TextInput
              version="v2"
              autoFocus
              data-test="hyperlink-input"
              name="url"
              value={formData['url']}
              onChange={handleChange}
              required
              placeholder="Enter URL"
              id="url"
              error={!!errorMessage}
            />
            <ValidationMessage version='v2' style={{ marginLeft: '10px', marginTop: '5px' }}>{errorMessage}</ValidationMessage>
          </Field>

          <Field>
            <FieldLabel version='v2' htmlFor='text'>Display Text</FieldLabel>
            <TextInput
              version='v2'
              name="text"
              value={formData['text']}
              onChange={handleChange}
              type="text"
              placeholder="Enter Text"
              autoComplete="off"
            />
          </Field>
          <Field>
            <FieldLabel version='v2' htmlFor='text'
            helpText={<Tooltip content="Optional title for the link. Use this to provide additional info beyond the display text. Shown on hover, can aid accessibility, but has limited SEO impact." position="top"><Icon icon="HelpDark" /></Tooltip>} 
            >Title</FieldLabel>
            <TextInput
              version='v2'
              name="title"
              value={formData['title']}
              onChange={handleChange}
              type="text"
              placeholder="Enter Title"
              autoComplete="off"
            />
          </Field>
          <div className='ToggleWrap'>
            <ToggleSwitch
              label="Open link in new tab"
              name='inNewTab'
              checked={formData['inNewTab']}
              onChange={handleToggle}
              testId='hyperlink-open-in-new-tab'
            />
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <Button version='v2' data-testid="hyperlink_delete_button" onClick={closeModal} key="cancel" buttonType="tertiary">
            <span>Cancel</span>
          </Button>
          <Button version='v2' data-testid="hyperlink_add_button" key="addButton" id="addUrlBtn" onClick={handleSubmit} disabled={!!errorMessage}>
            <span>Add Link</span>
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div>
  )
}

export const handleLinkMouseDown = (event, editor: ReactEditor) => {
  if (event) event.preventDefault()
  if (!(editor.selection || editor.savedSelection)) {
    return
  }

  cbModal({
    modalProps: {
      shouldReturnFocusAfterClose: false,
      onClose: () => setOldSelection(editor)
    },
    component: (thisProps) => <ModalComponent editor={editor} {...thisProps} />
  })
}

export const HyperLinkOverlay = (props) => {
  const editor = useSlate();
  const handleMouseDown = useCallback((event) => {

    if (event) event.preventDefault()
    if (!(editor.selection || editor.savedSelection)) {
      return
    }
    editor.setFullScreen();
    cbModal({
      modalProps: {
        shouldReturnFocusAfterClose: false,
        onClose: () => setOldSelection(editor)
      },
      component: (thisProps) => <ModalComponent editor={editor} {...thisProps} {...props} />
    })
  }, [])

  return (
    <React.Fragment>
      {props.children({
        handleMouseDown,
        active: isLinkActive(editor)
      })}
    </React.Fragment>
  )
}

export const ShortcutOpenHyperlinkOverlay = (event, editor, format, registryObj) => {

  event.preventDefault()

  if (!(editor.selection || editor.savedSelection)) {
    return
  }

  cbModal({
    modalProps: {
      shouldReturnFocusAfterClose: false,
      onClose: () => setOldSelection(editor)
    },
    component: (thisProps) => <ModalComponent editor={editor} {...thisProps} />
  })

}

export default HyperLinkOverlay
